// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__Tp5i-","alertIcon":"ConfirmModal_alertIcon__1lTTl"};